import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

// Components
import Icon from "components/CommonIcon/Icon";

const Stepper = ({
  max,
  onIncrease,
  onDecrease,
  value,
  min,
  error,
  smaller,
}) => {
  const disableDec = !value || value === min;
  const disableInc = value >= max;

  return (
    <div
      data-testid="stepper"
      className={cn(
        "border border-gray-light rounded-sm shadow-input-booking bg-white flex items-center p-12",
        {
          error,
          "stepper-smaller": smaller,
        }
      )}>
      <div
        data-testid="stepper-decrease"
        className={cn("flex items-center justify-items-start", {
          "opacity-50": disableDec,
          "cursor-pointer": !disableDec,
        })}
        onClick={!disableDec ? onDecrease : null}
        span={3}>
        <Icon name="minus" fontSize="text-12" />
      </div>
      <div className="flex items-center justify-center w-50">
        <h5 className="font-mulish font-bold text-16 leading-26 tracking-16 uppercase select-none">
          {disableDec ? min : value}
        </h5>
      </div>
      <div
        data-testid="stepper-increase"
        className={cn("flex items-center justify-items-end", {
          "opacity-50": disableInc,
          "cursor-pointer": !disableInc,
        })}
        span={3}
        onClick={disableInc ? null : onIncrease}>
        <Icon name="plus" fontSize="text-12" />
      </div>
    </div>
  );
};

Stepper.defaultProps = {
  min: 0,
};

Stepper.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
  onDecrease: PropTypes.func,
  onIncrease: PropTypes.func,
};

export default Stepper;
